import { render, staticRenderFns } from "./GreenConfig.vue?vue&type=template&id=12a20f27"
import script from "./GreenConfig.vue?vue&type=script&lang=ts"
export * from "./GreenConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports